export function processDate(date: string) {
  let parts: Array<string>;

  parts = date.split('/');
  return new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
}

export function parseTimestamp(timestampStr: number) {
  return new Date(
    new Date(timestampStr).getTime() + new Date(timestampStr).getTimezoneOffset() * 60 * 1000
  );
}

export function getQueryParams(url: string) {
  const paramArr = url.slice(url.indexOf('?') + 1).split('&');
  const params: any = {};
  paramArr.map(param => {
    const [key, val] = param.split('=');
    params[key] = decodeURIComponent(val);
  })
  return params;
}

export function getURLParameterByName(name: string) {
  var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export function addOrUpdateUrlParam(uri: string, paramKey: string, paramVal: string) {
  var re = new RegExp("([?&])" + paramKey + "=[^&#]*", "i");
  if (re.test(uri)) {
    uri = uri.replace(re, '$1' + paramKey + "=" + paramVal);
  } else {
    var separator = /\?/.test(uri) ? "&" : "?";
    uri = uri + separator + paramKey + "=" + paramVal;
  }
  return uri;
}